module.exports = __webpack_public_path__ + "img/google-play.892fe9ac.svg";